<template>
    <b-modal id="aroundModal" title="둘러보기 등록" size="md">
        <div class="table_list">
            <div class="modal_table">
                <table class="write">
                    <colgroup>
                        <col width="50">
                        <col width="300">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>파일명</th>
                            <td>
                                <div class="form_inline">
                                    <button class="btn btn_md btn_blue" @click="fn_aroundFileUpload">파일업로드</button>
                                    <input type="file" ref="aroundFile" @change="fn_fileAroundChange" hidden>
                                    <ul class="file_list" v-if="item.around_file_nm != ''">                                        
                                        <li><a href="" download="">{{item.around_file_nm}}</a></li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>설명</th>
                            <td><input type="text" class="form_control" placeholder="입력하세요" v-model="item.around_expl"></td>
                        </tr>
                        <tr>
                            <th>노출여부</th>
                            <td>
                                <div class="form_inline">
                                    <div class="form_radio">
                                        <input type="radio" id="display_radio1" name="display_radio" value="Y" checked v-model="item.display_yn">
                                        <label for="display_radio1">노출</label>
                                    </div>
                                    <div class="form_radio">
                                        <input type="radio" id="display_radio2" name="display_radio" value="N" v-model="item.display_yn">
                                        <label for="display_radio2">비노출</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="ok">
            <b-button class="btn btn_md btn_deepblue" @click="fn_around_reg(),ok">
                {{ '저장' }}
            </b-button>
        </template>
        <alert-modal 
            :id="'alert'"
            :text="showAlertMsg" 
            :btnRight="'확인'" 
            :oneBtn="false"
            :isShow="showAlert"
            :className="'btn_brown'"
            v-on:update:showSetting="fn_showSet"
        />
    </b-modal>
</template>

<script>
    import axios from 'axios'
    import AlertModal from "@/modal/common/alertModal.vue"
    import alertutill from "@/mixin/alertModalUtill";
    
    export default {
        name: 'aroundModal',
        mixins: [alertutill],
        components: {
        'alert-modal' : AlertModal,
            //'confirm-modal': AlertModal,
        },
        props: {
            item: Object,
        },
        data() {
            return {
                upLoadFile : {
                    upFile : ''
                }
            }
        },
        methods : {
             fn_aroundFileUpload(){
                let fileInputElement = this.$refs.aroundFile;
                fileInputElement.click();
            },
            fn_fileAroundChange(e){
                this.upLoadFile.upFile = e.target.files[0];
                this.item.around_file_nm = this.upLoadFile.upFile.name;                
                //강제 리렌더링
                this.$forceUpdate();
            },
            async fn_around_reg(){

                console.log("@@@@ this.item : %o",this.item);
                if(this.item.status != "M" || this.upLoadFile.upFile != ""){

                console.log("@@@@ this.item : %o",this.item);

                var frm = new FormData();

                frm.append("file",this.upLoadFile.upFile);
                frm.append("key",JSON.stringify(this.item));

                axios
                    .post("/api/admin/contents/regAround", frm, {
                            "Content-Type": "multipart/form-data",
                            "Accept-Language" : "ko"})
                    .then((res) => {                            
                        console.log("@@@@ res : %o",res);

                        if(res.data.result == "ok"){
                            // let msg = "저장되었습니다";
                            // this.fn_open_alert(msg);
                            alert("저장되었습니다.");
                            this.$root.$emit('bv::hide::modal','AroundModal')
                            
                        }else{
                            let msg = res.data.errorMsg;
                            this.fn_open_alert(msg);
                        }                                              
                    })
                    .catch((err) => console.log(err));
                }else{
                    this.fn_open_alert("파일을 선택해 주세요");
                }
            }
        }
    }
</script>

<style>

</style>